"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmpty = exports.GalleryAssetsContainer = exports.ActionButtonsContainer = exports.AssetImg = exports.OfferAssetCard = void 0;
const elements_1 = require("@src/components/elements");
const styled_components_1 = __importDefault(require("styled-components"));
exports.OfferAssetCard = styled_components_1.default.div `
	width: 100px;
	height: 100px;
	border-radius: ${props => props.theme.borderRadius.base};
	background-color: ${props => props.theme.color.gray9};
	margin: 0.25rem;
`;
exports.AssetImg = styled_components_1.default.img `
	border-radius: inherit;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;
exports.ActionButtonsContainer = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	gap: 2rem;
	justify-content: center;
`;
exports.GalleryAssetsContainer = styled_components_1.default.div `
	margin-top: 0.5rem;
	margin-bottom: 0.5rem;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
`;
exports.StyledEmpty = (0, styled_components_1.default)(elements_1.Empty) `
	margin: 0.5rem 0;
`;
